import { observable, makeObservable } from 'mobx';
import { createModelSchema, primitive } from 'serializr';
import { optional } from '@vromo/models';

type Category = 'signature' | 'photo' | 'file' | '';

export class Upload {
    id: number | null = null;

    url: string | null = null;
    created: number | null = null;
    category: Category | null = null;

    constructor(url?: string) {
        makeObservable(this, {
            url: observable,
            created: observable,
            category: observable
        });

        if (url) this.url = url;
    }
}

createModelSchema(Upload, {
    id: optional(primitive()),
    url: optional(primitive()),
    created: optional(primitive()),
    category: optional(primitive())
});
